export default __webpack_public_path__ + "static/media/appBackgroundMob.00ed4e1d.jpg";